module.exports = __webpack_public_path__ + "img/icon-disconnect.ad3e0368.png";